import styled from 'styled-components';
import {ListTitleTextDefaultBox} from './list-title-text.default.box';
import {JACKPOT_WIDGET, RED_TIGER_JACKPOT} from "../../constants";

export const ListTitleTextMrGreenBox = styled(ListTitleTextDefaultBox)`
    background: none;
    border-left: 0;
    
    .${JACKPOT_WIDGET} & {
        border-left: 0;
    }
    
    .${RED_TIGER_JACKPOT} & {
        border-left: 0;
    }
`;

